import React, { createContext, useContext, useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';

const defaultContact = {
  phone: '628132216607',
  email: 'edcworkss@gmail.com',
  instagram: 'https://www.instagram.com/edc.workss/',
  gdrive_portfolio: 'https://drive.google.com/drive/folders/your-folder-id',
};

const ContactContext = createContext(defaultContact);

export function ContactProvider({ children }) {
  const [contact, setContact] = useState(defaultContact);

  useEffect(() => {
    const fetchContact = async () => {
      try {
        const { data, error } = await supabase
          .from('site_settings')
          .select('phone, email, instagram, gdrive_portfolio')
          .eq('id', 'main')
          .maybeSingle();

        if (!error && data) {
          setContact({
            phone: data.phone || defaultContact.phone,
            email: data.email || defaultContact.email,
            instagram: data.instagram || defaultContact.instagram,
            gdrive_portfolio: data.gdrive_portfolio || defaultContact.gdrive_portfolio,
          });
        }
      } catch {
        // keep default
      }
    };
    fetchContact();
  }, []);

  return (
    <ContactContext.Provider value={contact}>
      {children}
    </ContactContext.Provider>
  );
}

export function useContact() {
  return useContext(ContactContext);
}
